import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainBillsComponent } from "./components/main-bills.component";
import { MainBillComponent } from "./components/main-bill.component";
import { MainBillGYHComponent } from "./components/main-bill-gyh.component";
import { ListBillsComponent } from "./components/dummy/list-bills.component";
import { SearchBillsComponent } from "./components/dummy/search-bills.component";
import { HistoryBillComponent } from "./components/dummy/history-bill.component";
import { EmitDataBillComponent } from "./components/dummy/emitData-bill.component";
import { ReceiveDataBillComponent } from "./components/dummy/receiveData-bill.component";
import { EmitGYHBillComponent } from "./components/dummy/emitGYH-bill.component";
import { ReceiveGYHBillComponent } from "./components/dummy/receiveGYH-bill.component";
import { DataBillComponent } from "./components/dummy/data-bill.component";
import { HeaderBillComponent } from "./components/dummy/header-bill.component";
import { ModalPaymentComponent } from "./components/dummy/modal-payment.component";
import { ModalBillComponent } from "./components/dummy/modal-bill.component";
import { ModalDownloadComponent } from "./components/dummy/modal-download.component";
import { HeaderGYHBillComponent } from "./components/dummy/headerGYH-bill.component";
import { ModalModule } from 'ngx-bootstrap/modal';
import { RouterModule } from '@angular/router';
import { BillsRoutes } from './bills.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BillsService } from "../../injections/bills.service";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from "../../common/shared.module";
import { FilterByPaidBills } from '../../pipes/filter-unpaid.pipe';
import { Sanitize } from '../../pipes/sanitizeHTML.pipe';



@NgModule({
  declarations: [MainBillsComponent, MainBillComponent, MainBillGYHComponent, ListBillsComponent, SearchBillsComponent, HistoryBillComponent,
    EmitDataBillComponent, ReceiveDataBillComponent, HeaderBillComponent, HeaderGYHBillComponent, DataBillComponent, ModalPaymentComponent, FilterByPaidBills, EmitGYHBillComponent, 
    ReceiveGYHBillComponent, ModalBillComponent, ModalDownloadComponent, Sanitize
  ],
  imports: [
    CommonModule,
    BillsRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule,
    ModalModule.forRoot()
  ],
  providers: [BillsService]
})

export class BillsModule{} 


// WEBPACK FOOTER //
// ./src/app/modules/bills/bills.module.ts